import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from '../shared/api.service';
import { NbToastrService, NbGlobalPhysicalPosition, NbStepperComponent,NbDialogService, NbDateService } from '@nebular/theme';
import { IfStmt } from '@angular/compiler';
import { ConfirmationService } from 'primeng/api';
import { MatStepper, MatSelectChange } from '@angular/material';
import { config } from '../../../config.prod';
import { previewImg } from './dialog/transcriptpreview.component';
import { EducationalFormComponent } from './dialog/educationalform.component';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { EducationalFormYearComponent } from './dialog/educationalformyearly.component';
import { addEducationalDetailsSemesterGPA } from './dialog/educationalformsemgpa.component';
import { addEducationalDetailsSemesterSGPI } from './dialog/educationalformsemsgpi.component';
import { addMasterEducationalDetailsSemesterSGPI } from './dialog/mastereducationalformsemsgpi.component';
import { EducationalFormBafComponent } from './dialog/educationalformbaf.component';
import { MatRadioChange } from '@angular/material';
import { educationalformyearlyBcom } from './dialog/educationalformyearlyBcom.component';
import { addEducationalDetailsSemesterBVOCGPA } from './dialog/educationalformsemBVOCgpa.component';
import { EducationalFormYearAddOnComponent } from './dialog/educationalformyearlyAddOn.component';
import { EducationalFormYearSecndRowComponent } from './dialog/educationalformyearlySecondCol.component';
import { PaymentModelComponent } from './../payment-success/payment.component';
import { TranscriptDialogComponent } from './dialog/transcriptdialogcomponent';
import { addEducationalBAyearly } from './dialog/addEducationalBAyearly.component';
import { educationalformwithoutBBI } from './dialog/educationalformwithoutBBI.component';
import { educationalformsemsgpibscitnewformat } from './dialog/educationalformsemsgpibscitnewformat.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NbToastStatus } from '@nebular/theme/components/toastr/model';
import { APPLY_TOKEN_KEY } from '../shared/apply-token.interceptor';


@Component({
  selector: 'app-apply',
  templateUrl: './apply.component.html',
  styleUrls: ['./apply.component.scss'],
  providers: [ ConfirmationService]
})
export class ApplyComponent implements OnInit {
  
  checked:boolean=true;
  checked1:any;
  checked2:any;
  max: Date;
  firstForm: FormGroup;

  captchaForm: FormGroup;
  //downloadTCForm: FormGroup;
  downloadTCpreferredoptionForm: FormGroup;
  emailForm: FormGroup;
  courierForm: FormGroup;
  //JuniorCollegeTCForm: FormGroup;
  // DegreeCollegeTCForm: FormGroup;
  // AidedDegreeCollegeTCForm: FormGroup;
  // UnAidedDegreeCollegeTCForm: FormGroup;
  // MastersCollegeTCForm: FormGroup;
  // MATCCForm: FormGroup;
  // MScByPapersTCForm: FormGroup;
  // MScByResearchTCForm: FormGroup;
  // PhDTCForm: FormGroup;
  // ChemistryTCForm: FormGroup;
  // CertificateCoursesTCForm: FormGroup;
  // NewCoursesTCForm: FormGroup;
  secondForm: FormGroup;
  thirdForm: FormGroup;
  firstFormData: { };
  secondFormData: { };
  isHidden: boolean = true;
  userId='';
  firstname: any;
  middlename: any;
  lastname: any;
  fathername:any;
  mothername:any;
  preferredoptionfortranscriptdownload:any;
  newaddress:any;
  isNewAddressSame:any;
  couremail:any;
  courmobile:any;
  etelno:any;
  emobileno:any;
  newemail:any;

  tcyearenrollment:any;
  enrollmentyearstandard:any;
  tcyearleaving:any;
  leavingyearstandard:any;
  notes:any;
  tcyearrequiredfrom:any;
  tcyearrequiredto:any;
  numofcouriers:any;
  tcyearpattern;

  tcname: any;
  gender: any;
  joiningyear: any;
  standard: any;
  academicyear: any;
  academicclass: any;
  academicmark: any;
  tcrequiredyear: any;
  tcrequirecfrom: any;
  tcrequiredto: any;
  reason: any;
  university: any;
  address: any;
  telno: any;
  mobile: any;
  email: any;
  score1: any;
  score2: any;
  //2nd step //
  user_id: any;
  transUploadUrl = config.docUploadUrl;
  siteKey = config.siteKey;
  index: number;
  position: string;
  status1: string;
  status: string;
  semestervalue: any;
  yearValue : any;
  showNextButton = false;
  showNextButtonPic = false;
  showNextButtonDob = false;
  showNextButtonTenc = false;
  showNextButtonMarksheet = false;
  applicantFile = [];
  loadingdoc= false
  degreeValue: any;
  //end of 2nd step//

  //Payment tab start//
  applicant_id: any;
  user_data: any;
  accessCode: any;
  secureUrl: any;
  encRequest: any;
  //Payment tab end//

  Show9= false;
  Show10 = false;
  startYear: any;
  endYear: any;
  years_array: number[];
  tranReqYear=[];
  stillStudy = '';
  furtherStudy = '';
  stillStudingErr = false;
  whatappNo: any;

  @ViewChild('stepper') stepper: NbStepperComponent;
  setdate: string;
  grescore1: any;
  grescore2: any;
  satscore1: any;
  satscore2: any;
  gmatscore1: any;
  gmatscore2: any;
  tofelscore1: any;
  tofelscore2: any;
  anyotherscorename: any;
  anyotherscore1: any;
  anyotherscore2: any;
  grevalue :any;
  satvalue :any;
  gmatvalue :any;
  tofelvalue : any;
  anyothervalue :any;
  greExamName: string;
  satExamName: string;
  gmatExamName: string;
  tofelExamName: string;
  dob:any;
  academicremark:any;
  seat_number:any;
  mu_seat_number:any;
  educational_detail:any;
 
  courseValue: any;

  showNextButtonEdu = false;
  educatonalData = [];

  pattern_show = false;
  course_system_show = false;
  Show1 = false;
  Show2 = false;
  Show3 = false;
  Show4 = false;
  Show5 = false;
  Show6 = false;
  Show7 = false;
  Show8 = false;
  showSemYear = false;
  payment_before_error = false;
  specialisationShow: string;
  specialisation_data: any;
  mobileCountryCode: any;
  userDetails: any;
  educations: any;
  marksheets: any;
  user_name: any;
  emailPayment: any;
  mobilePayment: any;
  amountPayment: any;
  course_data: any;
  show_patteren: any;
  fourthcheck: boolean = false;
  fifthcheck: boolean = false;
  sixthcheck: boolean = false;
  seventhcheck: boolean = false;
  eighttcheck: boolean = false;
  ninthcheck: boolean = false;
  firstcheck: boolean = false;
  secondcheck: boolean = false;
  thirdcheck: boolean = false;
  show_year_sem = [];
  exam: any;
  dobc =  [];
  tenc = [];
  photo = [];
  atkt_data = [];
  entranceExamMarksheet: [];
  imageName = config.serverUrl + '/upload/profile_pic/MarksheetSample.png';
  captchaText;
  captchaId;
  captcha;
  // Signed by the server when the applicant row is created; authorises every
  // later step of the wizard. Bound in the upload URLs, sent as a header by
  // ApplyTokenInterceptor for everything else.
  applyToken = '';
  svg:SafeHtml;
  validation_messages;
  toasterTimeout: any;

  constructor(private fb: FormBuilder,protected api : ApiService,private toasterService: NbToastrService,
    private confirmationService: ConfirmationService,
    private dialogService: NbDialogService,
    private sanitizer: DomSanitizer,
    private toastrService: NbToastrService,
    private dateService: NbDateService<Date>) {
      this.max = this.dateService.addMonth(this.dateService.today(), -120);
  }


  ngOnInit() {
    this.firstForm = this.fb.group({
      stud_surnameCtrl: ['', Validators.required],
      stud_fnameCtrl: ['', Validators.required],
      stud_mnameCtrl: [''],
      stud_fathernameCtrl: [''],
      stud_mothernameCtrl: [''],
      //nameOnTCCtrl: ['', Validators.required],
      studDOBCtrl: ['', Validators.required],
      genderCtrl: ['', Validators.required],
      yojAcademicYear1nCtrl: [''],
      standardCtrl: [''],
      yojAcademicYear2nCtrl: [''],
      classCtrl: [''],
      remarkCtrl: [''],
      TCyearCtrl: [''],
      class1Ctrl: [''],
      class2Ctrl: [''],
      grescore1Ctrl: [''],
      grescore2Ctrl: [''],
      satscore1Ctrl: [''],
      satscore2Ctrl: [''],
      gmatscore1Ctrl: [''],
      gmatscore2Ctrl: [''],
      tofelscore1ctrl: [''],
      tofelscore2ctrl: [''],
      anyotherscorenamectrl: [''],
      anyotherscore1ctrl: [''],
      anyotherscore2ctrl: [''],
      reasonCtrl: ['', [Validators.required,Validators.pattern]],
      universitiesCtrl: [''],
      examCtrl:[''],
      addressCtrl: [''],
      telnumberCtrl: [''],
      mobileCtrl: ['', Validators.required],
      emailidCtrl: ['', Validators.required],
      enrollmentYearStandardCtrl: ['', Validators.required],
      leavingYearStandardCtrl: ['', Validators.required],
      notesCtrl: [''],
      TCyearEnrollmentCtrl: ['', Validators.required],
      TCyearLeavingCtrl: ['', Validators.required],
      // TCyearrequiredfromCtrl: ['', Validators.required],
      // TCyearrequiredtoCtrl: ['', Validators.required],
      mobile1Ctrl: [''],
      phonecodeCtrl: ['91', Validators.required],
      stillStudyingCtrl :  ['', Validators.required],
      furtherStudiesCtrl :  [''],
      TCpatternCtrl: ["", Validators.required],
      //captchaCtrl:['', Validators.required]
      educationlevelCtrl: ["", Validators.required],
      educationCourseCtrl: [""],
      specialisationCtrl:[''],
      
    });

   
    this.captchaForm = this.fb.group({
     captchaCtrl:['', Validators.required]
    });
    // The server checks this captcha on addFirstFormData, so load one up front.
    this.reloadcaptcha();

  
    this.secondForm = this.fb.group({
      secondCtrl: ['', Validators.required],
      additional_credits: [""],
      course_type : [''],
      pattern_course : [''],
      course_system : [''],
      dobdocCtrl:[''],
    });

    this.thirdForm = this.fb.group({
      fNPaymentCtrl : [''],
      mobilePaymentCtrl : [''],
      emailPaymentCtrl : [''],
      amountPaymentCtrl : ['']
    });

    this.downloadTCpreferredoptionForm = this.fb.group({
      downloadTCpreferredoptionCtrl: ['', Validators.required]
     });

   

     this.emailForm = this.fb.group({
      alternateemailcheckCtrl: [''],
      emailFormCtrl: [''],
      courierFormCtrl: ['', Validators.required],
      //mobile1Ctrl: ['', Validators.required],
      telnoCtrl: [''],
      //phonecodeCtrl: ['', Validators.required],
     });

    
    this.courierForm = this.fb.group({
      courierFormCtrl: ['', Validators.required],
      addressForCourierCtrl: ['', Validators.required],
      courEmailCtrl: [''],
      sameCheckCtrl: ['', Validators.required],
      courMobileCtrl: ['', Validators.required],
      alternateemailcheckcourierCtrl: ['']
     });
   

    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
  }

  toggle(checked: boolean) {
    this.checked = !checked;
  }

  togglealternateemailcheck(checked1) {
    this.checked1 = checked1.target.checked;

  }

  togglealternateemailcheckcourier(checked2) {
    this.checked2 = checked2.target.checked;
  }

  firstFormSubmit(user_id){
    // var error=this.findInvalidControls(this.firstForm.controls)
    
    const config = {
      position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
    };

    if(this.firstForm.controls.stillStudyingCtrl.value != null && this.firstForm.controls.stillStudyingCtrl.value != '' && this.firstForm.controls.stillStudyingCtrl.value != undefined){
      this.stillStudingErr = false
    }else{
      this.stillStudingErr = true;
    }

    

  this.firstForm.controls.stud_surnameCtrl.markAsDirty();
   this.firstForm.controls.stud_fnameCtrl.markAsDirty();
   this.firstForm.controls. stud_mnameCtrl.markAsDirty();
   this.firstForm.controls.stud_fathernameCtrl.markAsDirty();
   this.firstForm.controls. stud_mothernameCtrl.markAsDirty();
   this.firstForm.controls.educationlevelCtrl.markAsDirty();
   //this.firstForm.controls.educationCourseCtrl.markAsDirty();
   //this.firstForm.controls.nameOnTCCtrl.markAsDirty();
   this.firstForm.controls.studDOBCtrl.markAsDirty();
   this.firstForm.controls.genderCtrl.markAsDirty();
   this.firstForm.controls.yojAcademicYear1nCtrl.markAsDirty(),
   this.firstForm.controls.standardCtrl.markAsDirty(),
   this.firstForm.controls.yojAcademicYear2nCtrl.markAsDirty(),
   this.firstForm.controls.classCtrl.markAsDirty(),
   this.firstForm.controls.remarkCtrl.markAsDirty();
   this.firstForm.controls.TCyearCtrl.markAsDirty(),
   this.firstForm.controls.class1Ctrl.markAsDirty(),
   this.firstForm.controls.class2Ctrl.markAsDirty(),
   this.firstForm.controls. reasonCtrl.markAsDirty();
   //this.firstForm.controls.universitiesCtrl.markAsDirty();
   this.firstForm.controls.addressCtrl.markAsDirty();
   this.firstForm.controls.telnumberCtrl.markAsDirty();
   this.firstForm.controls.mobileCtrl.markAsDirty();
   this.firstForm.controls.emailidCtrl.markAsDirty();
   this.firstForm.controls.enrollmentYearStandardCtrl.markAsDirty();
   this.firstForm.controls.leavingYearStandardCtrl.markAsDirty();
   this.firstForm.controls.notesCtrl.markAsDirty();
   this.firstForm.controls.TCyearEnrollmentCtrl.markAsDirty();
   this.firstForm.controls.TCyearLeavingCtrl.markAsDirty();
  //  this.firstForm.controls.TCyearrequiredfromCtrl.markAsDirty();
  //  this.firstForm.controls.TCyearrequiredtoCtrl.markAsDirty();
   this.downloadTCpreferredoptionForm.controls.downloadTCpreferredoptionCtrl.markAsDirty();
  this.emailForm.controls.courierFormCtrl.markAsDirty();
  this.firstForm.controls.phonecodeCtrl.markAsDirty();
  this.firstForm.controls.specialisationCtrl.markAsDirty();
   
    //if (this.firstForm.valid && this.downloadTCForm.valid && this.JuniorCollegeTCForm.valid)
    if (this.firstForm.valid) {
      var date = this.firstForm.controls.studDOBCtrl.value;
      var datePipe = new DatePipe("en-IN");
      this.setdate = datePipe.transform(date, 'dd-MM-yyyy');
      this.firstFormData = {
        stud_surnameCtrl:
        this.firstForm.controls.stud_surnameCtrl.value.toUpperCase(),
      stud_fnameCtrl: this.firstForm.controls.stud_fnameCtrl.value
        ? this.firstForm.controls.stud_fnameCtrl.value.toUpperCase()
        : "",
      stud_mnameCtrl: this.firstForm.controls.stud_mnameCtrl.value
        ? this.firstForm.controls.stud_mnameCtrl.value.toUpperCase()
        : "",
      stud_fathernameCtrl: this.firstForm.controls.stud_fathernameCtrl.value
        ? this.firstForm.controls.stud_fathernameCtrl.value.toUpperCase()
        : "",
      stud_mothernameCtrl: this.firstForm.controls.stud_mothernameCtrl.value
        ? this.firstForm.controls.stud_mothernameCtrl.value.toUpperCase()
        : "",
      //nameOnTCCtr:this.firstForm.controls.nameOnTCCtrl.value,
      studDOBCtrl:this.setdate,
      genderCtrl:this.firstForm.controls.genderCtrl.value,
      yojAcademicYear1nCtrl:this.firstForm.controls.yojAcademicYear1nCtrl.value,
      standardCtrl:this.firstForm.controls.standardCtrl.value,
      yojAcademicYear2nCtrl:this.firstForm.controls.yojAcademicYear2nCtrl.value,
      classCtrl:this.firstForm.controls.classCtrl.value,
      remarkCtrl:this.firstForm.controls.remarkCtrl.value,
      TCyearCtrl:this.firstForm.controls.TCyearCtrl.value,
      class1Ctrl:this.firstForm.controls.class1Ctrl.value,
      class2Ctrl:this.firstForm.controls.class2Ctrl.value,
      reasonCtrl:this.firstForm.controls.reasonCtrl.value,
      universitiesCtrl:this.firstForm.controls.universitiesCtrl.value,
      examCtrl:this.firstForm.controls.examCtrl.value,
      addressCtrl:this.firstForm.controls.addressCtrl.value,
      telnumberCtrl:this.firstForm.controls.telnumberCtrl.value,
      mobileCtrl:this.firstForm.controls.mobileCtrl.value,
      emailidCtrl:this.firstForm.controls.emailidCtrl.value,
      educationlevelCtrl:this.firstForm.controls.educationlevelCtrl.value,
      educationCourseCtrl : this.firstForm.controls.educationCourseCtrl.value,
      enrollmentYearStandardCtrl:this.firstForm.controls.enrollmentYearStandardCtrl.value,
      leavingYearStandardCtrl:this.firstForm.controls.leavingYearStandardCtrl.value,
      notesCtrl:this.firstForm.controls.notesCtrl.value,
      TCyearEnrollmentCtrl:this.firstForm.controls.TCyearEnrollmentCtrl.value,
      TCyearLeavingCtrl:this.firstForm.controls.TCyearLeavingCtrl.value,
      // TCyearrequiredfromCtrl:this.firstForm.controls.TCyearrequiredfromCtrl.value,
      // TCyearrequiredtoCtrl:this.firstForm.controls.TCyearrequiredtoCtrl.value,
      mobile1Ctrl:this.firstForm.controls.mobile1Ctrl.value,
      emailFormCtrl:this.emailForm.controls.emailFormCtrl.value,
      telnoCtrl:this.emailForm.controls.telnoCtrl.value,
      courierFormCtrl:this.emailForm.controls.courierFormCtrl.value,
      downloadTCpreferredoptionCtrl:this.downloadTCpreferredoptionForm.controls.downloadTCpreferredoptionCtrl.value,
      addressForCourierCtrl:this.courierForm.controls.addressForCourierCtrl.value,
      sameCheckCtrl:this.courierForm.controls.sameCheckCtrl.value,
      courEmailCtrl:this.courierForm.controls.courEmailCtrl.value,
      courMobileCtrl:this.courierForm.controls.courMobileCtrl.value,
      mob_country_code:this.firstForm.controls.phonecodeCtrl.value,
      stillStudying :this.firstForm.controls.stillStudyingCtrl.value,
      furtherStudies :this.firstForm.controls.furtherStudiesCtrl.value?this.firstForm.controls.furtherStudiesCtrl.value:null,
      specialisationlevel:this.firstForm.controls.specialisationCtrl.value, 
      firstcheck: this.firstcheck,
        secondcheck: this.secondcheck,
        thirdcheck: this.thirdcheck,
        fourthcheck: this.fourthcheck,
        fifthcheck: this.fifthcheck,
        sixthcheck: this.sixthcheck,
        seventhcheck: this.seventhcheck,
        eighttcheck: this.eighttcheck,
        ninthcheck: this.ninthcheck,
        whatapp_no:this.whatappNo,
          }
          if(user_id==undefined || user_id==''){
            // Anonymous callers must pass the server-side captcha; it is
            // single-use, so a failed attempt needs a fresh one.
            this.firstFormData['captchaId'] = this.captchaId;
            this.firstFormData['captchaText'] = this.captchaForm.controls.captchaCtrl.value;
            this.api.addFirstFormData(this.firstFormData).subscribe(data => {
              if(data['status']==200){
                /*
                 * The credential for the rest of the wizard. /apply has no
                 * account yet, so every later step is authorised by this signed
                 * token instead of by a session. ApplyTokenInterceptor sends it
                 * as X-Apply-Token; the upload widgets put it in the query
                 * string, because PrimeNG posts a bare form and sets no headers.
                 * Stored before preview(), which is the first call that needs it.
                 */
                this.applyToken = data['applyToken'] || '';
                this.storeApplyToken(this.applyToken);
                this.user_id = data['data']['id'];
                this.preview();
                this.confirmationService.confirm({
                  message:
                    "Your data has been succesfully added !!!",
                  header: "Successfull",
                  icon: "pi pi-check",
                  rejectVisible: false,
                  acceptLabel: "Ok",
                });
                // this.toasterService.show('Successfully saved!!!...', 'Success', config);
                this.user_id = data['data']['id'];
                this.setThirdFormValue(this.user_id);
                this.userId = data['data']['id'];
                this.firstcheck = data["data"]["yearfirstcheck"];
                this.secondcheck = data["data"]["yearsecondcheck"];
                this.thirdcheck = data["data"]["yearthirdcheck"];
                this.fourthcheck = data["data"]["semfirstcheck"];
                this.fifthcheck = data["data"]["semsecondcheck"];
                this.sixthcheck = data["data"]["semthirdcheck"];
                this.seventhcheck = data["data"]["semforthcheck"];
                this.eighttcheck = data["data"]["semfifthcheck"];
                this.ninthcheck = data["data"]["semsixcheck"];
                this.firstname = data['data']['firstname'];
                this.middlename = data['data']['middlename'];
                this.lastname = data['data']['lastname'];
                this.fathername = data['data']['fathername'];
                this.mothername = data['data']['mothername'];
                this.tcname = data['data']['tcname'];
                this.gender = data['data']['gender'];
                this.joiningyear = data['data']['joiningyear'];
                this.standard = data['data']['standard'];
                this.academicyear = data['data']['academicyear'];
                this.academicclass = data['data']['academicclass'];
                this.academicmark = data['data']['firstname'];
                this.tcrequiredyear = data['data']['tcrequiredyear'];
                this.tcrequirecfrom = data['data']['tcrequirecfrom'];
                this.tcrequiredto = data['data']['tcrequiredto'];
                this.reason = data['data']['reason'];
                this.university = data['data']['university'];
                this.exam = data['data']['exam_pattern'];
                this.address = data['data']['address'];
                this.telno = data['data']['telno'];
                this.mobile = data['data']['mobile'];
                this.email = data['data']['email'];
                this.etelno = data['data']['etelno'];
                this.emobileno = data['data']['emobileno'];
                this.mobileCountryCode = data['data']['mob_country_code'];
                this.newemail = data['data']['newemail'];
                this.tcyearenrollment = data['data']['enrollmentYear'];
                this.enrollmentyearstandard = data['data']['enrollmentYearStandard'];
                this.tcyearleaving = data['data']['leavingYear'];
                this.leavingyearstandard = data['data']['leavingYearStandard'];
                this.notes = data['data']['notes'];
                this.tcyearrequiredfrom = data['data']['tcyearfrom'];
                this.tcyearrequiredto = data['data']['tcyearto'];
                this.numofcouriers = data['data']['numofcouriers'];
                this.preferredoptionfortranscriptdownload = data['data']['preferredoptionfortranscriptdownload'];
                this.newaddress = data['data']['newaddress'];
                this.isNewAddressSame = data['data']['isNewAddressSame'];
                this.couremail = data['data']['couremail'];
                this.courmobile = data['data']['courmobile'];
                this.stepper.next();
              }
            }, err => {
              // 400 = captcha rejected, 429 = rate limited. The captcha was
              // burned either way, so fetch a new one.
              this.toasterService.show(
                (err && err.error && err.error.message) || 'Could not save your details. Please try again.',
                'Error', { status: NbToastStatus.DANGER });
              this.captchaForm.reset();
              this.reloadcaptcha();
            });
          }else if(user_id!=undefined || user_id!=''){
            // this.user_id = user_id;
            this.api.updateFirstformData(this.firstFormData,this.user_id).subscribe(data=>{
              if(data['status']==200){
                this.preview();
                this.setThirdFormValue(this.user_id);
                this.confirmationService.confirm({
                  message:
                    "Your data has been succesfully updated !!!",
                  header: "Successfull",
                  icon: "pi pi-check",
                  rejectVisible: false,
                  acceptLabel: "Ok",
                });
              //  this.toasterService.show('Successfully updated!!!...', 'Success', config);
               this.stepper.next();
              }
 
            });
           }
      }
      else{
        this.toasterService.show('Please fill mandatory details!!!...', 'Warning', config);
      }
      } 

  
      
  onFirstSubmit() {
    this.firstForm.markAsDirty();
  }

  onSecondSubmit() {
    this.secondForm.markAsDirty();
   
  }

  getData(event: MatSelectChange){
    this.semestervalue = event.source.value
  }

  getYear(event: MatSelectChange){

    this.yearValue = event.source.value
    
  }

  getDegree(event: MatSelectChange){
    this.degreeValue = event.source.value
    
  }

  onUpload(event: any, edu_year) {
    const reader = new FileReader();
    var duration = 10000;
    this.index += 1;
    this.position = 'top-right';
    this.status1 = 'success';
    const config = {
      position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
    };
    //this.ngOnInit();
    if (event.files && event.files.length) {
      const [file] = event.files;
      reader.readAsDataURL(file);
      var json = JSON.parse(event.xhr.response);
      var yourData = json.data; // or json["Data"]
      var yourStatus = json.status; // or json["Data"]
      var yourMessage = json.message; // or json["Data"]

      if (yourStatus == 200) {
        var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
        this.show_year_sem[update_array].file = yourData;
        this.preview();
        this.loadingdoc = false;
        this.toasterService.show(yourMessage, 'Success', config);
        this.api.getApplicantFiles(this.user_id).subscribe(data => {
          this.applicantFile = data['data']
          
          
          if(data['data'].length == this.show_year_sem.length){
            
            this.showNextButton = true
          }else{
            
            this.showNextButton = false
          }
        })
      } else if (yourStatus == 401) {
       // this.loading = false;
       this.loadingdoc = false;
       this.toasterService.show(yourMessage, 'Success', config);
      } else if (yourStatus == 400) {
       // this.loading = false;
       this.loadingdoc = false;
       this.toasterService.show(yourMessage, 'Success', config);
      }
    }
  }

  onSelect($event: any,value): void {
    var maxFileSize =  5120000;
    var imgArr = $event.files[0].name.split('.');
    var extension = imgArr[imgArr.length - 1].trim();
    this.loadingdoc = true;
    if ($event.files[0].size > maxFileSize) {
      this.confirmationService.confirm({
        message: 'Maximum file size should be 5 MB.',
        header: 'Invalid File Size',
        icon: 'pi pi-info-circle',
        rejectVisible : false,
        acceptLabel: 'Ok'
      });
      this.loadingdoc = false;
    }

    if(value!=undefined && (extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='JPG' && extension!='JPEG' && extension!='PNG' && extension!='pdf' && extension!='Pdf' && extension!='docx' && extension!='DOCX') ) {
      this.confirmationService.confirm({
        message: 'Please upload your transcript in .jpeg or .jpg or .png or .docx formats',
        header: 'Invalid File Type',
        icon: 'pi pi-info-circle',
        rejectVisible : false,
        acceptLabel: 'Ok'
      });
      this.loadingdoc = false;
    }

    if(value==undefined && (extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='pdf' && extension!='JPG' && extension!='JPEG' && extension!='PNG' && extension!='PDF' && extension!='docx' && extension!='DOCX')){
      this.confirmationService.confirm({
        message: 'Please upload your transcript in .jpeg or .jpg or .png or .pdf or .docx formats',
        header: 'Invalid File Type',
        icon: 'pi pi-info-circle',
        rejectVisible : false,
        acceptLabel: 'Ok'
      });
      this.loadingdoc = false;
    }
  }

  onView(imagename,imgType){
    
    this.dialogService.open(previewImg, {
      context: {
      arr : imagename,
      //arr : 'https://mu.admissiondesk.org/uiserver/upload/transcript/20086/HywOaKlgI.pdf',
      imgType : imgType
      },
    });
  }

  onDeleteMarklist(info,edu_year){
    var duration = 10000;
    this.position = 'top-right';
    this.status = 'success';
    this.api.deleteApplicantFile(info).subscribe(data => {
      var yourMessage = data['message']
      if(data['status'] == 200){
        this.preview();
        this.status = 'success';
        const config = {
          position: NbGlobalPhysicalPosition.TOP_RIGHT
        };
        this.toasterService.show(" "+yourMessage,`Success`,config);
        var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
        this.show_year_sem[update_array].file = null;
        this.api.getApplicantFiles(this.user_id).subscribe(data => {
          this.applicantFile = data['data']
          if(data['data'].length == this.show_year_sem.length){
            
            this.showNextButton = true
          }else{
            
            this.showNextButton = false
          }
        })
      }
    })
  }


  downldTemplate(){
    this.api.downloadTemplate().subscribe(data => {
			saveAs(data);    

    })
  }

  onThirdSubmit() {
    this.thirdForm.markAsDirty();
  }
  /*
   * sessionStorage, not localStorage: the token belongs to one half-finished
   * application in one tab, and should not outlive the browser session. Wrapped
   * because storage throws outright in some privacy modes.
   */
  storeApplyToken(token) {
    try {
      if (token) {
        sessionStorage.setItem(APPLY_TOKEN_KEY, token);
      } else {
        sessionStorage.removeItem(APPLY_TOKEN_KEY);
      }
    } catch (e) {
      // Non-fatal: the header just will not be sent, and the API answers 401.
    }
  }
  async resolved(captchaResponse: string) {
    
    await this.sendTokenToBackend(captchaResponse); 
  }
  //function to send the token to the node server
sendTokenToBackend(tok){
  //calling the service and passing the token to the service
  this.api.sendToken(tok).subscribe(
    data => {
      if(data.success)
      {
        this.isHidden = false;
      }
      else
      {
      this.isHidden = true;
      }
     
    },
    err => {
      this.isHidden = true;
      
    },
    () => {}
  );
}
  getCaptchactrl(){
    
     return this.captchaForm.get('captchaCtrl').hasError('required') ?'Captcha is required ' : '';
  }

  reloadcaptcha(){
    this.api.getCaptcha()
    .subscribe(
        (data: any) => {
        this.captchaId = data['data']['captchaId'];
        this.captcha =  data['data']['captchadata'];
        this.svg = this.sanitizer.bypassSecurityTrustHtml(this.captcha);
        err => console.error(err)
    });
}

checkcaptcha(): void {
  const enteredCaptcha = this.captchaForm.controls.captchaCtrl.value;
  const delay = 1000; // Set default delay in milliseconds

  // Clear any existing timeout to avoid multiple toasts
  if (this.toasterTimeout) {
    clearTimeout(this.toasterTimeout);
  }

  // Delay feedback for user input
  this.toasterTimeout = setTimeout(() => {
    if (!enteredCaptcha) {
      // Handle empty captcha
      this.toastrService.show(
        `Captcha is required!`,
        'Error',
        { duration: 1000, status: NbToastStatus.DANGER }
      );
      this.captchaForm.controls.captchaCtrl.setErrors({ required: true });
    } else {
      // Clear errors and show success
      this.captchaForm.controls.captchaCtrl.setErrors(null);
      this.toastrService.show(
        `Captcha matched!`,
        'Success',
        { duration: 1000, status: NbToastStatus.SUCCESS }
      );
    }
  }, delay); // Apply delay
}
 validate(){

    // if(this.firstForm.invalid){
    //   alert('Please Fill In All The Required Details!');
    // }

  }

  setThirdFormValue(applicant_id){
    
    this.api.getApplicantData(applicant_id).subscribe(data => {
      
      if(data['status']==200){
        this.user_name = data['data']['user_name'];
        this.emailPayment =  data['data']['user_email'];
        this.mobilePayment =  data['data']['user_mobile'];
        this.amountPayment  =  data['data']['amount'];
      }
    });
  }

  // async firstpayment(){
  //   this.payment_before_error = false;
  //   if(this.showNextButtonEdu == true && this.showNextButton == true){
  //     var user_id = this.user_id;
  //     var payment = await this.api.paymentrequest(user_id);
  //     payment.subscribe(
  //         data => {
  //           this.accessCode = data['data']['accessCode'];
  //           this.secureUrl = data['data']['secureUrl'];
  //           this.encRequest = data['data']['encRequest'];
  //           setTimeout(function(){ 
  //           this.loading = false;
  //             var myForm = <HTMLFormElement>document.getElementById('nonseamless');
  //             myForm.submit();
  //           }, 1000);
  //         },
  //         error => {
  //             
  //         }
  //     ); 
  //   }else{
  //     this.payment_before_error = true;
  //   }
  // }

  next(){
    this.stepper.next();
  }

  addEducationalDetails(id,user_id){
    var paid_amount = 'false';
    var admin_show = 'false';
      this.dialogService.open(EducationalFormComponent, {
        closeOnBackdropClick : false,
        context: {
          user_id : user_id,
          edu_id : id,
          amount_paid : paid_amount,
          admin_show : admin_show
        },
      }).onClose
      .subscribe(
        (data: any) => {
          if(data){
            this.position = 'top-right';
            this.status1 = 'success';
            const config = {
              position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
            };
            var yourMessage = 'Saved';
            this.toasterService.show(yourMessage, 'Success', config);
          }
          this.api.getApplicantEducationalValues(user_id).subscribe(data => {
            this.educatonalData = data['data']
            this.preview();
            if(data['data'].length >= 1){
              this.showNextButtonEdu = true
            }else{
              this.showNextButtonEdu = false
            }
          })
          
        }
      )
    }

  onDeleteEducation(info){
    var duration = 10000;
    this.position = 'top-right';
    this.status = 'success';
    this.api.deleteEducation(info).subscribe(data => {
      var yourMessage = data['message']
      if(data['status'] == 200){
        this.status = 'success';
        this.preview();
        const config = {
          position: NbGlobalPhysicalPosition.TOP_RIGHT
        };
        this.toasterService.show(" "+yourMessage,`Success`,config)
        this.api.getApplicantEducationalValues(this.user_id).subscribe(data => {
          this.educatonalData = data['data']
          if(data['data'].length >= 1){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
      }
    })
  }

  courseradioChange(event: MatRadioChange) {
    this.Show1 = false;
    this.Show2 = false;
    this.Show3 = false;
    this.Show4 = false;
    this.Show5 = false;
    this.Show6 = false;
    this.Show7 = false;
    this.Show8 = false;
    this.Show9= false;
    this.Show10= false;

    this.courseValue = event.value;
    
    if(event.value == 'Normal'){
      this.Show9= false;
      this.pattern_show = true;
      this.Show1 = false;
      this.Show6 = false;
      this.Show7 = false;
    }else if(event.value == 'Special'){
      this.Show9= false;
      this.Show1 = false;
      this.Show6 = false;
      this.Show7 = false;
      this.pattern_show = true;
      // if(this.firstForm.controls.TCyearEnrollmentCtrl.value > 2010){
      //   //this.Show1 = true;
      //   this.Show3 = true;
      // }else{
      //   //this.Show6 = true;
      //   this.Show2 = true;
      // }
      // this.pattern_show = false;
      this.course_system_show = false;
     } else if(event.value == 'BBI'){
      this.Show9= false;
        
        if(this.firstForm.controls.TCyearEnrollmentCtrl.value > 2014){
          
          this.Show3 = true;
        }else{
          
          this.Show2 = true;
        }
        this.pattern_show = false;
        this.course_system_show = false;
      }else if(event.value == 'BMS'){
        this.Show9= false;
        
        if(this.firstForm.controls.TCyearEnrollmentCtrl.value > 2014){
          
          this.Show3 = true;
        }else{
          
          this.Show2 = true;
        }
        this.pattern_show = false;
        this.course_system_show = false;
      }else if(event.value == 'Master'){
        this.Show9= false;
        this.specialisationShow = 'true'
        this.pattern_show = true;
        this.Show1 = false;
        this.Show6 = false;
        this.Show7 = false;
        this.pattern_show = true;
        this.course_system_show = false;
      // this.pattern_show = false;
      // this.course_system_show = false;
      // this.Show5 = true;
    }else if(event.value == 'BVOC'){
      this.Show9= false;
      
      this.specialisationShow = 'false'
      //this.bvocShowSub = 'true';
      //this.pattern_show = true;
      this.Show1 = false;
      this.Show6 = false;
      this.Show7 = false;
      this.Show8 = true;
      // this.pattern_show = true;
      // this.course_system_show = false;
     // this.Show5 = true;
    }else if(event.value == "AddOn"){
      this.pattern_show = false;
      this.course_system_show = false;
      this.Show9 = true;
      
    }
  }

  patternradioChange(event: MatRadioChange) {
    this.Show1 = false;
    this.Show2 = false;
    this.Show3 = false;
    this.Show4 = false;
    this.Show5 = false;
    this.Show6 = false;
    this.Show7 = false;
    this.Show8 = false;
    this.Show9 = false;
    this.Show10 = false;
    
    
      if(event.value == 'semester'){
        this.course_system_show = true;
        this.Show2 = false;
      }else{
        this.course_system_show = false;
        this.Show2 = true;
      }
   
  }

  systemradioChange(event: MatRadioChange) {
    this.Show1 = false;
    this.Show2 = false;
    this.Show3 = false;
    this.Show4 = false;
    this.Show5 = false;
    this.Show6 = false;
    this.Show7 = false;
    this.Show8 = false;
    this.Show9 = false;
    this.Show10 = false;
    
    if(event.value == 'GPA'){
      this.Show3 = true;
    }else if(event.value == 'SGPI'){
      this.Show4 = true;
    }else if(event.value == 'without'){
      this.Show10 = true;
    }
  }

  addEducationalFormYearSecndRowComponent(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    if(this.firstForm.controls['educationlevelCtrl'].value == 'Master'){
      this.specialisationShow = "true"
    }else{
      this.specialisationShow = "false"
    }
    this.dialogService.open(EducationalFormYearSecndRowComponent, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        seat_number: this.seat_number,
        mu_seat_number: this.mu_seat_number,
        showSpecialization: this.specialisationShow,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        specialisationlevel_auto : this.firstForm.controls['specialisationCtrl'].value,
        leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
          this.educational_detail = data['data'];
          this.seat_number = this.educational_detail.seat_number;
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          data['show_year_sem'].forEach(semData=>{
            if(semData.name=='SemesterFive' && semData.id !=null){
              this.mu_seat_number = this.educational_detail.seat_number;
            }
          })
          if(data['data'].length == this.show_year_sem.length){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  addEducationalDetailsYearly(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    if(this.firstForm.controls['educationlevelCtrl'].value == 'Master'){
      this.specialisationShow = "true"
    }else{
      this.specialisationShow = "false"
    }
    this.dialogService.open(EducationalFormYearComponent, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        showSpecialization: this.specialisationShow,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
       
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          if(data['data'].length == this.show_year_sem.length){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  addEducationalDetailsSemesterGPA(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    if(this.firstForm.controls['educationlevelCtrl'].value == 'Master'){
      this.specialisationShow = "true"
    }else{
      this.specialisationShow = "false"
    }
    this.dialogService.open(addEducationalDetailsSemesterGPA, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        seat_number: this.seat_number,
        mu_seat_number: this.mu_seat_number,
        showSpecialization: this.specialisationShow,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year, 
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        specialisationlevel_auto : this.firstForm.controls['specialisationCtrl'].value,
        leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
        sgpi_gpa : this.secondForm.controls['course_system'].value,
      },
    }).onClose
    .subscribe(
      (data: any) => {
        
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
          this.educational_detail = data['data'];
          this.seat_number = this.educational_detail.seat_number;

        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          data['show_year_sem'].forEach(semData=>{
              if(semData.name=='SemesterFive' && semData.id !=null){
                this.mu_seat_number = this.educational_detail.seat_number;
              }
            })
            

          if(data['data'].length == this.show_year_sem.length){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  addEducationalDetailsSemesterSGPI(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    if(this.firstForm.controls['educationlevelCtrl'].value == 'Master'){
      this.specialisationShow = "true"
    }else{
      this.specialisationShow = "false"
    }
    this.dialogService.open(addEducationalDetailsSemesterSGPI, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        seat_number: this.seat_number,
        mu_seat_number: this.mu_seat_number,
        showSpecialization: this.specialisationShow,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        specialisationlevel_auto : this.firstForm.controls['specialisationCtrl'].value,
        leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
        sgpi_gpa : this.secondForm.controls['course_system'].value,
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
          this.educational_detail = data['data'];
          this.seat_number = this.educational_detail.seat_number;
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          // this.photo = data['photo']
          // this.tenc = data['tenc']
          
          
          
          data['show_year_sem'].forEach(semData=>{
            if(semData.name=='SemesterFive' && semData.id !=null){
              this.mu_seat_number = this.educational_detail.seat_number;
            }
          })
          
          
          // if(this.firstForm.controls['furtherStudiesCtrl'].value == false  || this.firstForm.controls['reasonCtrl'].value == 'Other' || this.firstForm.controls['reasonCtrl'].value == 'PR'){
            // if(data['data'].length == this.show_year_sem.length && (this.photo != null || this.photo != undefined) && (this.tenc != null || this.tenc != undefined)){
              if(data['data'].length ==  this.show_year_sem.length){
                
              this.showNextButtonEdu = true
            }else{
              
              this.showNextButtonEdu = false
            }
          // }
        //   else if(this.firstForm.controls['furtherStudiesCtrl'].value == true){
        //   if(data['data'].length == this.show_year_sem.length){
        //     this.showNextButtonEdu = true
        //   }else{
        //     this.showNextButtonEdu = false
        //   }
        // }
        })
        
      }
    )
  }

  addMasterEducationalDetailsSemesterSGPI(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    if(this.firstForm.controls['educationlevelCtrl'].value == 'Master'){
      this.specialisationShow = "true"
    }else{
      this.specialisationShow = "false"
    }
    this.dialogService.open(addMasterEducationalDetailsSemesterSGPI, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        showSpecialization: this.specialisationShow,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        sgpi_gpa : this.secondForm.controls['course_system'].value,
        // leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
          this.educational_detail = data['data'];
          this.seat_number = this.educational_detail.seat_number;
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          data['show_year_sem'].forEach(semData=>{
            if(semData.name=='SemesterFive' && semData.id !=null){
              this.mu_seat_number = this.educational_detail.seat_number;
            }
          })
          if(data['data'].length == this.show_year_sem.length){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  addEducationalDetailsBaf(id,user_id){
    var paid_amount = 'false';
    var admin_show = 'false';
    this.dialogService.open(EducationalFormBafComponent, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          if(data['data'].length >= 1){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  addEducationalDetailsYearlyBcom(id,user_id){
    var paid_amount = 'false';
    var admin_show = 'false';
    this.dialogService.open(educationalformyearlyBcom, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,

      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          if(data['data'].length >= 1){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  addEducationalDetailsYearlyBVOCBcom(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    this.dialogService.open(addEducationalDetailsSemesterBVOCGPA, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        specialisationlevel_auto : this.firstForm.controls['specialisationCtrl'].value,
        // leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          if(data['data'].length == this.show_year_sem.length){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  addEducationalBAyearly(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    this.dialogService.open(addEducationalBAyearly,{
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        // showSpecialization: this.specialisationShow,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
       
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          if(data['data'].length == this.show_year_sem.length){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  educationalformwithoutBBI(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    this.dialogService.open(educationalformwithoutBBI,{
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        // showSpecialization: this.specialisationShow,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
       
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          if(data['data'].length == this.show_year_sem.length){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }
  addEducationalFormYearAddOnComponent(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    this.dialogService.open(EducationalFormYearAddOnComponent, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          if(data['data'].length == this.show_year_sem.length){
            this.showNextButtonEdu = true
          }else{
            this.showNextButtonEdu = false
          }
        })
        
      }
    )
  }

  educationalformsemsgpibscitnewformat(id,user_id,edu_year){
    var paid_amount = 'false';
    var admin_show = 'false';
    if(this.firstForm.controls['educationlevelCtrl'].value == 'Master'){
      this.specialisationShow = "true"
    }else{
      this.specialisationShow = "false"
    }
    this.dialogService.open(educationalformsemsgpibscitnewformat, {
      closeOnBackdropClick : false,
      context: {
        user_id : user_id,
        edu_id : id,
        amount_paid : paid_amount,
        admin_show : admin_show,
        seat_number: this.seat_number,
        mu_seat_number: this.mu_seat_number,
        showSpecialization: this.specialisationShow,
        course_name_auto : this.firstForm.controls['educationCourseCtrl'].value,
        college_year_auto : edu_year,
        enrollment_year_auto :this.firstForm.controls['TCyearEnrollmentCtrl'].value,
        specialisationlevel_auto : this.firstForm.controls['specialisationCtrl'].value,
        leaving_year_auto : this.firstForm.controls['TCyearLeavingCtrl'].value,
        sgpi_gpa : this.secondForm.controls['course_system'].value,
      },
    }).onClose
    .subscribe(
      (data: any) => {
        if(data){
          this.position = 'top-right';
          this.status1 = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT
          };
          var yourMessage = 'Saved';
          this.toasterService.show(yourMessage, 'Success', config);
          var update_array = this.show_year_sem.findIndex(obj => obj.name === edu_year);
          this.show_year_sem[update_array].id = data['data'].id;
          this.educational_detail = data['data'];
          this.seat_number = this.educational_detail.seat_number;
        }
        this.api.getApplicantEducationalValues(user_id).subscribe(data => {
          this.preview();
          this.educatonalData = data['data']
          // this.photo = data['photo']
          // this.tenc = data['tenc']
          
          
          
          data['show_year_sem'].forEach(semData=>{
            if(semData.name=='SemesterFive' && semData.id !=null){
              this.mu_seat_number = this.educational_detail.seat_number;
            }
          })
          
          
          // if(this.firstForm.controls['furtherStudiesCtrl'].value == false  || this.firstForm.controls['reasonCtrl'].value == 'Other' || this.firstForm.controls['reasonCtrl'].value == 'PR'){
            // if(data['data'].length == this.show_year_sem.length && (this.photo != null || this.photo != undefined) && (this.tenc != null || this.tenc != undefined)){
              if(data['data'].length ==  this.show_year_sem.length){
                
              this.showNextButtonEdu = true
            }else{
              
              this.showNextButtonEdu = false
            }
          // }
        //   else if(this.firstForm.controls['furtherStudiesCtrl'].value == true){
        //   if(data['data'].length == this.show_year_sem.length){
        //     this.showNextButtonEdu = true
        //   }else{
        //     this.showNextButtonEdu = false
        //   }
        // }
        })
        
      }
    )
  }


  getSelectedYear(){
    var d = new Date();
    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 55)).fill('').map((v, idx) => now - idx);
    if(this.firstForm.controls.TCyearEnrollmentCtrl.value && this.firstForm.controls.TCyearLeavingCtrl.value){
      this.startYear = this.firstForm.controls.TCyearEnrollmentCtrl.value;
      this.startYear = Number(this.startYear) 
      this.endYear = this.firstForm.controls.TCyearLeavingCtrl.value;
      this.endYear = Number(this.endYear)
    }

    for(let info of this.years_array){
      
      
      if(info >= this.firstForm.controls.TCyearEnrollmentCtrl.value && !this.tranReqYear.includes(info)){
        this.tranReqYear.push(info)
      }
    }
    
    
    //

      
  }

  stillStudyingChange(event: MatRadioChange){
    if(event.value == 'yes'){
      
      this.stillStudy = 'yes'
    }else{
      
      this.stillStudy = 'no'
    }
  }

  //  furtherStudies:
  furtherStudiesSelect(event: MatRadioChange){
    if(event.value == 'true'){
      
      this.furtherStudy = 'true'
    }else{
      
      this.furtherStudy = 'false'
    }
  }

  onNoSelect(event : any){
		if(event.target.checked == true){
			if(this.firstForm.controls.mobileCtrl.value){
        
        this.whatappNo = this.firstForm.controls.mobileCtrl.value;
        
      }
		}else{
			this.whatappNo = '';
		}
	}

  preview(){
    this.api.preview(this.user_id).subscribe(data =>{
      this.userDetails = data['userDetails'];
      this.marksheets = data['marksheets'];
      this.educations = data['educations'];
    })
  }

  async firstpayment(){
    this.payment_before_error = false;
    if(this.showNextButtonEdu == true && this.showNextButton == true &&( this.dobc.length > 0 || this.tenc.length > 0)){
      this.dialogService.open(PaymentModelComponent, {
        closeOnBackdropClick : false,
        context: {
          user_id : this.user_id,
          user_name : this.user_name,
          emailPayment : this.emailPayment,
          mobilePayment : this.mobilePayment,
          amountPayment  : this.amountPayment
        },
      }).onClose
      .subscribe(
        (data: any) => {
        }
      )
    }else{
      this.payment_before_error = true;
    }
  }

  onKeyPress(event: any){
    
    this.api.emailValues(this.firstForm.controls.emailidCtrl.value)
			.subscribe(
				(data: any) => {
				if(data['status'] == 400){  
					this.confirmationService.confirm({
						message: 'Your email id is already exists in our database!!! Check your Email for login credentials.',
						header: 'Confirmation',
						icon: 'pi pi-exclamation-triangle',
						accept: () => {
											
						},
						reject: () => {
							
						}
					});
				}else{
				}       
				err => console.error(err)
			});
  }

  selectPreferedOption($event){
    
    
    if($event == 'Email'){
      this.emailForm.controls['courierFormCtrl'].setValidators([]);
      this.emailForm.controls['courierFormCtrl'].updateValueAndValidity();
    }else{
      
      this.emailForm.controls['courierFormCtrl'].setValidators([Validators.required]);
      this.emailForm.controls['courierFormCtrl'].updateValueAndValidity();
     
    }
  }
  // Ibad Script Start
  OnlyNoAllowed(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      
      return false;
    }
    return true;
  }
  //Ibad Script Ends

  
  onLevelSelected(event){
    console.log('Eveneteeeeeeeeee',event)
    this.firstForm.controls["educationCourseCtrl"].setValidators([]);
    this.firstForm.controls["educationCourseCtrl"].updateValueAndValidity();
    if(event == 'Bachelor' || event == 'Master'){
      this.firstForm.controls["educationCourseCtrl"].setValidators([Validators.required,]);
      this.firstForm.controls["educationCourseCtrl"].updateValueAndValidity();
      this.api.getEduLevelCouses(event)
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.course_data = data['data'];
            
          }else{

          }
      });
    }else if(event == 'JC'){
      // this.firstForm.patchValue({
      //   educationCourseCtrl : 'H.S.C.'
      // })
      this.api.getEduLevelCouses(event)
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.course_data = data['data'];
            
          }else{

          }
      });
    }
  }

  onLevelSelected1(event){
    this.firstForm.controls["educationCourseCtrl"].setValidators([]);
    this.firstForm.controls["educationCourseCtrl"].updateValueAndValidity();
    if(event == 'B.M.M.' || event =='B.A.' || event=='B.M.S.' || event=='M.Com' || event=='B.A.M.M.C.'){
      this.firstForm.controls["educationCourseCtrl"].setValidators([Validators.required,]);
      this.firstForm.controls["educationCourseCtrl"].updateValueAndValidity();
      this.api.getSpecialisation(event)
      .subscribe(
        (data: any) => { 
          if(data['status'] == 200){
            this.specialisation_data = data['data'];
            
          }
      });
    }
  }

  onMenuItemSelected(event) {
    this.show_patteren = event;
    if (event == "Yearly") {
      this.fourthcheck = false;
      this.fifthcheck = false;
      this.sixthcheck = false;
      this.seventhcheck = false;
      this.eighttcheck = false;
      this.ninthcheck = false;
    } else if (event == "Semester") {
      this.firstcheck = false;
      this.secondcheck = false;
      this.thirdcheck = false;
    }
  }

  showOptionsOne(event, no) {
    if (no == "1") {
      this.firstcheck = event.checked;
      if(this.firstcheck == true){
        this.show_year_sem.push({
          no : '1',
          name : 'firstYear',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'firstYear');
      }
    } else if (no == "2") {
      this.secondcheck = event.checked;
      if(this.secondcheck == true){
        this.show_year_sem.push({
          no : '2',
          name : 'secondYear',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'secondYear');
      }
    } else if (no == "3") {
      this.thirdcheck = event.checked;
      if(this.thirdcheck == true){
        this.show_year_sem.push({
          no : '3',
          name : 'thirdYear',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'thirdYear');
      }
    } else if (no == "4") {
      this.fourthcheck = event.checked;
      if(this.fourthcheck == true){
        this.show_year_sem.push({
          no : '4',
          name : 'SemesterOne',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'SemesterOne');
      }
    } else if (no == "5") {
      this.fifthcheck = event.checked;
      if(this.fifthcheck == true){
        this.show_year_sem.push({
          no : '5',
          name : 'SemesterTwo',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'SemesterTwo');
      }
    } else if (no == "6") {
      this.sixthcheck = event.checked;
      if(this.sixthcheck == true){
        this.show_year_sem.push({
          no : '6',
          name : 'SemesterThree',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'SemesterThree');
      }
    } else if (no == "7") {
      this.seventhcheck = event.checked;
      if(this.seventhcheck == true){
        this.show_year_sem.push({
          no : '7',
          name : 'SemesterFour',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'SemesterFour');
      }
    } else if (no == "8") {
      this.eighttcheck = event.checked;
      if(this.eighttcheck == true){
        this.show_year_sem.push({
          no : '8',
          name : 'SemesterFive',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'SemesterFive');
      }
    } else if (no == "9") {
      this.ninthcheck = event.checked;
      if(this.ninthcheck == true){
        this.show_year_sem.push({
          no : '9',
          name : 'SemesterSix',
          id : null,
          file : null
        })
      }else{
        this.show_year_sem = this.show_year_sem.filter(array => array.name != 'SemesterSix');
      }
    }
  }

  additional_creditsChange(event: MatRadioChange) {
    if (event.value) {
      var info = { val: event.value, user_id: this.user_id };
      this.api.addAdditional_credits(info).subscribe((data) => {});
    }
  }

  public findInvalidControls(controls) {
  	const invalid = [];

  	for (const name in controls) {
  		if (controls[name].invalid) {
  			invalid.push(name);
  		}
  	}
  	return invalid;
  }  

  // select entransce exam marksheet
  onSelectEntranceExamMarksheet($event: any, value): void{
    var maxFileSize = 5120000;
    var imgArr = $event.files[0].name.split(".");
    var extension = imgArr[imgArr.length - 1].trim();
    this.loadingdoc = true;
    if ($event.files[0].size > maxFileSize) {
      this.confirmationService.confirm({
        message: "Maximum file size should be 5 MB.",
        header: "Invalid File Size",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

    if (value != undefined && extension != "jpg" && extension != "jpeg" && extension != "png" && extension != "JPG" && extension != "JPEG" && extension != "PNG" && extension != "pdf" && extension != "Pdf" && extension != "docx" && extension != "DOCX" ) {
      this.confirmationService.confirm({
        message:
          "Please upload your transcript in .jpeg or .jpg or .png or .docx formats",
        header: "Invalid File Type",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

    if (value == undefined && extension != "jpg" && extension != "jpeg" && extension != "png" && extension != "pdf" && extension != "JPG" && extension != "JPEG" && extension != "PNG" && extension != "PDF" && extension != "docx" && extension != "DOCX" ) {
      this.confirmationService.confirm({
        message:
          "Please upload your transcript in .jpeg or .jpg or .png or .pdf or .docx formats",
        header: "Invalid File Type",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

  }
  
  // upload entransce exam marksheet
  onUploadEntranceExamMarksheet(event: any, EntranceExamMaksheet){
  
  
  const reader = new FileReader();
  var duration = 10000;
  this.index += 1;
  this.position = "top-right";
  this.status1 = "success";
  const config = {
    position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
  };
  //this.ngOnInit();
  if (event.files && event.files.length) {
    const [file] = event.files;
    reader.readAsDataURL(file);
    var json = JSON.parse(event.xhr.response);
    var yourData = json.data; // or json["Data"]
    var yourStatus = json.status; // or json["Data"]
    var yourMessage = json.message; // or json["Data"]

    if (yourStatus == 200) {
       this.preview();
      this.loadingdoc = false;
      // this.toasterService.show(yourMessage, "Success", config);
      this.api.getApplicantFilesOne(this.user_id).subscribe((data) => {
      this.entranceExamMarksheet = data['data'];
      
      
      if(data['data'].length > 0){
        
        this.showNextButtonMarksheet = true
      }else{
        
        this.showNextButtonMarksheet = false
      }
      
        
      });
    } else if (yourStatus == 401) {
      // this.loading = false;
      this.loadingdoc = false;
      this.toasterService.show(yourMessage, "Success", config);
    } else if (yourStatus == 400) {
      // this.loading = false;
      this.loadingdoc = false;
      this.toasterService.show(yourMessage, "Success", config);
    }
  }
  }
   
  // view entransce exam marksheet
  onViewexaMarksheet(imagename, imgType) {
  
  
  this.dialogService.open(previewImg, {
    context: {
      arr: imagename,
      //arr : 'https://mu.admissiondesk.org/uiserver/upload/transcript/20086/HywOaKlgI.pdf',
      imgType: imgType,
    },
  });
  }
 
  // delete entransce exam marksheet
  onDeleteexamMarksheet(info){
  
  var duration = 10000;
  this.position = 'top-right';
  this.status = 'success';
  this.api.deleteApplicantFileConsolidate(info).subscribe(data => {
    
    var yourMessage = data['message']
    if(data['status'] == 200){
      // this.preview();
      // this.getApplicantEducationalValues();
      this.status = 'success';
      const config = {
        position: NbGlobalPhysicalPosition.TOP_RIGHT
      };
      this.toasterService.show(" "+yourMessage,`Success`,config)
      this.api.getApplicantFilesOne(this.user_id).subscribe(data => {
        this.entranceExamMarksheet= data['data']
        // this.lock_transcript = data['lock_transcript'];
        if (data["data"].length == this.show_year_sem.length){
          
          this.showNextButton = true
        }else{
          
          this.showNextButton = false
        }
      })
    }
  })
  }


   // select dob
   onSelectDob($event: any, value): void{
    var maxFileSize = 5120000;
    var imgArr = $event.files[0].name.split(".");
    var extension = imgArr[imgArr.length - 1].trim();
    this.loadingdoc = true;
    if ($event.files[0].size > maxFileSize) {
      this.confirmationService.confirm({
        message: "Maximum file size should be 5 MB.",
        header: "Invalid File Size",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

    if (value != undefined && extension != "jpg" && extension != "jpeg" && extension != "png" && extension != "JPG" && extension != "JPEG" && extension != "PNG" && extension != "pdf" && extension != "Pdf" && extension != "docx" && extension != "DOCX" ) {
      this.confirmationService.confirm({
        message:
          "Please upload your transcript in .jpeg or .jpg or .png or .docx formats",
        header: "Invalid File Type",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

    if (value == undefined && extension != "jpg" && extension != "jpeg" && extension != "png" && extension != "pdf" && extension != "JPG" && extension != "JPEG" && extension != "PNG" && extension != "PDF" && extension != "docx" && extension != "DOCX" ) {
      this.confirmationService.confirm({
        message:
          "Please upload your transcript in .jpeg or .jpg or .png or .pdf or .docx formats",
        header: "Invalid File Type",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

  }
  
  // upload dob
  onUploadDob(event: any, EntranceExamMaksheet){
  
  
  const reader = new FileReader();
  var duration = 10000;
  this.index += 1;
  this.position = "top-right";
  this.status1 = "success";
  const config = {
    position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
  };
  //this.ngOnInit();
  if (event.files && event.files.length) {
    const [file] = event.files;
    reader.readAsDataURL(file);
    var json = JSON.parse(event.xhr.response);
    var yourData = json.data; // or json["Data"]
    var yourStatus = json.status; // or json["Data"]
    var yourMessage = json.message; // or json["Data"]

    if (yourStatus == 200) {
       this.preview();
      this.loadingdoc = false;
      // this.toasterService.show(yourMessage, "Success", config);
      this.api.getApplicantFileDob(this.user_id).subscribe((data) => {
      this.dobc = data['data'];
      
      
      
      if(data['data'].length > 0){
        
        this.showNextButtonDob = true
      }else{
        
        this.showNextButtonDob = false
      }
        
      });
    } else if (yourStatus == 401) {
      // this.loading = false;
      this.loadingdoc = false;
      this.toasterService.show(yourMessage, "Success", config);
    } else if (yourStatus == 400) {
      // this.loading = false;
      this.loadingdoc = false;
      this.toasterService.show(yourMessage, "Success", config);
    }
  }
  }
   
  // view dob
  onViewDob(imagename, imgType) {
  
  
  this.dialogService.open(previewImg, {
    context: {
      arr: imagename,
      //arr : 'https://mu.admissiondesk.org/uiserver/upload/transcript/20086/HywOaKlgI.pdf',
      imgType: imgType,
    },
  });
  }
 
  // delete dob
  onDeleteDob(info){
  
  var duration = 10000;
  this.position = 'top-right';
  this.status = 'success';
  this.api.deleteApplicantFileDob(info).subscribe(data => {
    
    var yourMessage = data['message']
    if(data['status'] == 200){
      // this.preview();
      // this.getApplicantEducationalValues();
      this.status = 'success';
      const config = {
        position: NbGlobalPhysicalPosition.TOP_RIGHT
      };
      this.toasterService.show(" "+yourMessage,`Success`,config)
      this.api.getApplicantFileDob(this.user_id).subscribe(data => {
        this.dobc= data['data']
        // this.lock_transcript = data['lock_transcript'];
        if (data["data"].length == this.show_year_sem.length){
          this.showNextButtonDob = true
        }else{
          this.showNextButtonDob = false
        }
      })
    }
  })
  }


   // tenc 
   onSelecttenc($event: any, value): void{
    var maxFileSize = 5120000;
    var imgArr = $event.files[0].name.split(".");
    var extension = imgArr[imgArr.length - 1].trim();
    this.loadingdoc = true;
    if ($event.files[0].size > maxFileSize) {
      this.confirmationService.confirm({
        message: "Maximum file size should be 5 MB.",
        header: "Invalid File Size",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

    if (value != undefined && extension != "jpg" && extension != "jpeg" && extension != "png" && extension != "JPG" && extension != "JPEG" && extension != "PNG" && extension != "pdf" && extension != "Pdf" && extension != "docx" && extension != "DOCX" ) {
      this.confirmationService.confirm({
        message:
          "Please upload your transcript in .jpeg or .jpg or .png or .docx formats",
        header: "Invalid File Type",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

    if (value == undefined && extension != "jpg" && extension != "jpeg" && extension != "png" && extension != "pdf" && extension != "JPG" && extension != "JPEG" && extension != "PNG" && extension != "PDF" && extension != "docx" && extension != "DOCX" ) {
      this.confirmationService.confirm({
        message:
          "Please upload your transcript in .jpeg or .jpg or .png or .pdf or .docx formats",
        header: "Invalid File Type",
        icon: "pi pi-info-circle",
        rejectVisible: false,
        acceptLabel: "Ok",
      });
      this.loadingdoc = false;
    }

  }
  
  // tenc
  onUploadtenc(event: any, EntranceExamMaksheet){
  
  
  const reader = new FileReader();
  var duration = 10000;
  this.index += 1;
  this.position = "top-right";
  this.status1 = "success";
  const config = {
    position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
  };
  //this.ngOnInit();
  if (event.files && event.files.length) {
    const [file] = event.files;
    reader.readAsDataURL(file);
    var json = JSON.parse(event.xhr.response);
    var yourData = json.data; // or json["Data"]
    var yourStatus = json.status; // or json["Data"]
    var yourMessage = json.message; // or json["Data"]

    if (yourStatus == 200) {
       this.preview();
      this.loadingdoc = false;
      // this.toasterService.show(yourMessage, "Success", config);
      this.api.getApplicantFiletenc(this.user_id).subscribe((data) => {
      this.tenc = data['data'];
      
      
      
      if(data['data'].length > 0){
        
        this.showNextButtonTenc = true
      }else{
        
        this.showNextButtonTenc = false
      }
        
      });
    } else if (yourStatus == 401) {
      // this.loading = false;
      this.loadingdoc = false;
      this.toasterService.show(yourMessage, "Success", config);
    } else if (yourStatus == 400) {
      // this.loading = false;
      this.loadingdoc = false;
      this.toasterService.show(yourMessage, "Success", config);
    }
  }
  }
   
  //tenc 
  onViewtenc(imagename, imgType) {
  
  
  this.dialogService.open(previewImg, {
    context: {
      arr: imagename,
      //arr : 'https://mu.admissiondesk.org/uiserver/upload/transcript/20086/HywOaKlgI.pdf',
      imgType: imgType,
    },
  });
  }
 
  // tenc 
  onDeletetenc(info){
  
  var duration = 10000;
  this.position = 'top-right';
  this.status = 'success';
  this.api.deleteApplicantFiletenc(info).subscribe(data => {
    
    var yourMessage = data['message']
    if(data['status'] == 200){
      // this.preview();
      // this.getApplicantEducationalValues();
      this.status = 'success';
      const config = {
        position: NbGlobalPhysicalPosition.TOP_RIGHT
      };
      this.toasterService.show(" "+yourMessage,`Success`,config)
      this.api.getApplicantFiletenc(this.user_id).subscribe(data => {
        this.tenc= data['data']
        // this.lock_transcript = data['lock_transcript'];
        if (data["data"].length == this.show_year_sem.length){
          this.showNextButtonTenc = true
        }else{
          this.showNextButtonTenc = false
        }
      })
    }
  })
  }

  open(EducationalDialogNo){
    const config = {
      position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
    };
    if (EducationalDialogNo == 1) {
        this.dialogService.open(TranscriptDialogComponent, {
          closeOnBackdropClick : false,
          context: {
            user_id : this.user_id,
          },
        }).onClose
          .subscribe((data: any) => {
          if (data) {
            this.preview();
            this.loadingdoc = false;
              this.api.getApplicantAtkt(this.user_id).subscribe((data) => {
                  this.atkt_data = data['data'];
                  this.toasterService.show(" "+'Upload Completed',"Success");
              });
          }else{
          // this.loading = false; 
              } 
            })
          } else {
              console.error("Function Open () : invalid number ");
    }
  }

  onDeleteAtkt(info){
      var duration = 10000;
      this.position = 'top-right';
      this.status = 'success';
      this.api.deleteApplicantAtkt(info).subscribe(data => {
        var yourMessage = data['message']
        if(data['status'] == 200){
          this.status = 'success';
          const config = {
            position: NbGlobalPhysicalPosition.TOP_RIGHT
          };
          this.toasterService.show(" "+yourMessage,`Success`,config)
          this.api.getApplicantAtkt(this.user_id).subscribe(data => {
            this.atkt_data= data['data'] 
          })
        }
      })
      
  }


     // select photop
    onSelectphoto($event: any, value): void{
      var maxFileSize = 5120000;
      var imgArr = $event.files[0].name.split(".");
      var extension = imgArr[imgArr.length - 1].trim();
      this.loadingdoc = true;
      if ($event.files[0].size > maxFileSize) {
        this.confirmationService.confirm({
          message: "Maximum file size should be 5 MB.",
          header: "Invalid File Size",
          icon: "pi pi-info-circle",
          rejectVisible: false,
          acceptLabel: "Ok",
        });
        this.loadingdoc = false;
      }
  
      if (value != undefined && extension != "jpg" && extension != "jpeg" && extension != "png" && extension != "JPG" && extension != "JPEG" && extension != "PNG") {
        this.confirmationService.confirm({
          message:
            "Please upload your transcript in .jpeg or .jpg or .png formats",
          header: "Invalid File Type",
          icon: "pi pi-info-circle",
          rejectVisible: false,
          acceptLabel: "Ok",
        });
        this.loadingdoc = false;
      }
  
      if (value == undefined && extension != "jpg" && extension != "jpeg" && extension != "png" && extension != "JPG" && extension != "JPEG" && extension != "PNG") {
        this.confirmationService.confirm({
          message:
            "Please upload your transcript in .jpeg or .jpg or .png formats",
          header: "Invalid File Type",
          icon: "pi pi-info-circle",
          rejectVisible: false,
          acceptLabel: "Ok",
        });
        this.loadingdoc = false;
      }
  
    }
    
    // upload photop
    onUploadphoto(event: any, EntranceExamMaksheet){
    
    
    const reader = new FileReader();
    var duration = 10000;
    this.index += 1;
    this.position = "top-right";
    this.status1 = "success";
    const config = {
      position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
    };
    //this.ngOnInit();
    if (event.files && event.files.length) {
      const [file] = event.files;
      reader.readAsDataURL(file);
      var json = JSON.parse(event.xhr.response);
      var yourData = json.data; // or json["Data"]
      var yourStatus = json.status; // or json["Data"]
      var yourMessage = json.message; // or json["Data"]
  
      if (yourStatus == 200) {
         this.preview();
        this.loadingdoc = false;
        // this.toasterService.show(yourMessage, "Success", config);
        this.api.getApplicantFilephoto(this.user_id).subscribe((data) => {
        this.photo = data['data'];
        
      
        
        if(data['data'].length > 0){
          
          this.showNextButtonPic = true
        }else{
          
          this.showNextButtonPic = false
        }
          
        });
      } else if (yourStatus == 401) {
        // this.loading = false;
        this.loadingdoc = false;
        this.toasterService.show(yourMessage, "Success", config);
      } else if (yourStatus == 400) {
        // this.loading = false;
        this.loadingdoc = false;
        this.toasterService.show(yourMessage, "Success", config);
      }
    }
    }
     
    // view photop
    onViewphoto(imagename, imgType) {
    
    
    this.dialogService.open(previewImg, {
      context: {
        arr: imagename,
        //arr : 'https://mu.admissiondesk.org/uiserver/upload/transcript/20086/HywOaKlgI.pdf',
        imgType: imgType,
      },
    });
    }
   
    // delete photop
    onDeletephoto(info){
    
    var duration = 10000;
    this.position = 'top-right';
    this.status = 'success';
    this.api.deleteApplicantFilephoto(info).subscribe(data => {
      
      var yourMessage = data['message']
      if(data['status'] == 200){
        // this.preview();
        // this.getApplicantEducationalValues();
        this.status = 'success';
        const config = {
          position: NbGlobalPhysicalPosition.TOP_RIGHT
        };
        this.toasterService.show(" "+yourMessage,`Success`,config)
        this.api.getApplicantFilephoto(this.user_id).subscribe(data => {
          this.photo= data['data'];
          // this.lock_transcript = data['lock_transcript'];
          if (data["data"].length == this.show_year_sem.length){
            this.showNextButtonPic = true
          }else{
            this.showNextButtonPic = false
          }
        })
      }
    })
    }
  
}
